<template>
  <div class="character-list">
    <BaseQuotePhoto
      v-for="character in items"
      :key="character.id"
      class="character-list__character"
      :author="character"
      :class="{ 'character-list__character--delimited': items.length > 1 }"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseQuotePhoto from '~/components/BaseComponents/BaseQuotePhoto.vue';
  import type { TAuthor } from '~/types/components/BaseQuotePhoto';

  export default defineNuxtComponent({
    name: 'CharactersList',
    components: {
      BaseQuotePhoto,
    },

    props: {
      items: {
        type: Array as PropType<TAuthor[]>,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .character-list {
    &__character {
      &:first-child {
        border-top: 1px solid $stroke-color--1;
      }

      border-bottom: 1px solid $stroke-color--1;
    }
  }
</style>
